import { Component } from 'react';
import AppDynamicFilterModal from '../../partials/AppDynamicFilterModal';

export class MyComplaintsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: 'updatedAt',
        order_direction: 'DESC',
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: 'customerName',
        label: 'Customer Name',
        type: 'text',
        placeholder: 'Customer Name',
      },
      {
        name: 'loanAccountNumber',
        label: 'Loan Account Number (LAN)',
        type: 'text',
        placeholder: 'Loan Account Number (LAN)',
      },
      {
        name: 'queryType',
        label: 'Query Type',
        type: 'select',
        options: _enum.COMPLAINT_QUERY_TYPE,
        placeholder: 'Query Type',
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };
  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(MyComplaintsSearch);
